import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../components/webform";
import { MiamiPin } from "../../../app-constants";
import { Link } from "gatsby";

function Gettouch(props) {
  return (
    <div className="gettouch  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Connect">
              <h2>Let's Connect With Our Experts</h2>
            </div>
            <p>
              Get valuable consultation on your project idea. Our top-tier
              developers are here to help with all your{" "}
              <Link to="/mobile-app-development" target="_blank" rel="noopener">
                mobile app development
              </Link>{" "}
              queries.
            </p>
            <div className="map_loc">{MiamiPin}</div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
